import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrBookingWindowBucket.ts
var t = () => e("bookingWindowBucket");
//#endregion
export { t as useTrBookingWindowBucket };
